export function continuacaoDoHistorico(texto) {
  const tokens = (texto || '').replace(/\s+/g, ' ').trim().split(' ').filter(t => t);

  let inicio = 0;
  while (inicio < tokens.length && !/\d/.test(tokens[inicio])) inicio++;

  if (inicio === 0 || inicio >= tokens.length) return '';

  let resto = tokens.slice(inicio).join(' ');
  resto = resto.replace(/^\d{2}\/\d{2}(\/\d{2,4})?(\s+\d{2}:\d{2}(:\d{2})?)?\s*/, '');

  return resto.trim();
}

const espacos = t => (t || '').replace(/\s+/g, ' ').trim();

function removerTrecho(texto, trecho) {
  if (!trecho) return texto;
  const posicao = texto.toUpperCase().indexOf(trecho.toUpperCase());
  return posicao < 0 ? texto : texto.slice(0, posicao) + ' ' + texto.slice(posicao + trecho.length);
}

const OPERACOES_BANCO = [
  'ORDEM BANCARIA', 'TRANSFERENCIA RECEBIDA', 'TRANSF RECEBIDA', 'TRANSFERIDO DA POUPANCA',
  'PIX RECEBIDO', 'PIX', 'TED CREDITO EM CONTA', 'DOC CREDITO EM CONTA', 'CREDITO EM CONTA', 'TED', 'DOC',
  'DEPOSITO ONLINE', 'DEPOSITO EM DINHEIRO', 'DEP DINHEIRO ATM', 'DEPOSITO',
  'RECEBIMENTOS DIVERSOS', 'RECEBIMENTO DE FORNECEDOR', 'RECEBIMENTO FORNECEDOR', 'RECEBIMENTO',
  'COBRANCA', 'CREDITO', 'DEVOLUCAO DE PAGAMENTO', 'DEVOLUCAO', 'ESTORNO', 'TARIFA', 'BB RENDE FACIL', 'RENDE FACIL',
];

const semAcento = t => (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '');

export function nomeDoHistorico(historico) {
  let texto = ' ' + espacos(semAcento(historico).toUpperCase().replace(/[.\-–]+/g, ' ')) + ' ';

  OPERACOES_BANCO.forEach(op => {
    while (texto.indexOf(' ' + op + ' ') >= 0) texto = texto.replace(' ' + op + ' ', ' ');
  });

  return texto.split(' ')
    .filter(t => t && !/\d/.test(t))
    .join(' ')
    .trim();
}

export function operacaoDoHistorico(historico, documento, nome) {
  const resto = removerTrecho(removerTrecho(espacos(historico), espacos(nome)), espacos(documento));

  return resto.split(' ')
    .filter(t => t && !/\d/.test(t))
    .join(' ')
    .replace(/^[\s\-–]+|[\s\-–]+$/g, '');
}

export function sugestoesDaContraparte(historico, documento, nome, limite = 300, prefixo = '') {
  const n = espacos(nome);
  if (!n) return [];

  const d = espacos(documento);
  const operacao = operacaoDoHistorico(historico, d, n);

  const lista = d ? [`${d} ${n}`, n] : [n];
  if (operacao) lista.push(`${operacao} ${n}`);
  if (operacao && d) lista.push(`${operacao} ${d} ${n}`);

  const vistos = {};
  return lista
    .map(t => (prefixo + t).slice(0, limite).trim())
    .filter(t => {
      if (vistos[t]) return false;
      vistos[t] = true;
      return true;
    });
}

export default function sugestoesDoHistorico(texto, limite = 300) {
  const historico = (texto || '').replace(/\s+/g, ' ').trim();

  if (!historico) return [];

  const tokens = historico.split(' ');
  const ehNumero = t => /^\d+$/.test(t);
  const lista = [];

  let inicio = 0;
  while (inicio < tokens.length && !ehNumero(tokens[inicio])) inicio++;

  for (let i = inicio; i < tokens.length; i++) {
    if (!ehNumero(tokens[i])) break;
    lista.push(tokens.slice(i).join(' '));
  }

  let depois = inicio;
  while (depois < tokens.length && ehNumero(tokens[depois])) depois++;
  if (depois < tokens.length) lista.push(tokens.slice(depois).join(' '));

  lista.push(historico);

  const vistos = {};
  return lista
    .map(t => (t || '').trim().slice(0, limite))
    .filter(t => {
      if (t.length < 3 || vistos[t]) return false;
      vistos[t] = true;
      return true;
    })
    .slice(0, 6);
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/sugestoes-historico.js